import { css, SerializedStyles } from '@emotion/react';

export const videoStyles = (): SerializedStyles =>
    css({
        width: '100%',
    });
